











import { reactive, defineComponent, computed } from '@vue/composition-api';
import { useStore } from '@/components/composables/useStore';
import { Store } from 'vuex';
import { RootState } from '@/store/Store';
import { CheckboxFilter } from '@/models/filters/Filters';

interface State {
  value: boolean;
}

interface Props {
  storePath: string;
  filterCheckbox: CheckboxFilter;
}

const Component = defineComponent({
  name: 'CheckboxBar',

  props: {
    storePath: String,
    filterCheckbox: Object,
  },

  setup(props: Props) {
    const store: Store<RootState> = useStore();

    const state: State = reactive({
      value: false,
    });

    function filter() {
      store.dispatch(`${props.storePath}/setCheckboxFilterField`, state.value);
    }

    return {
      state,
      filter,
    };
  },
});

export default Component;
